<template>
  <!-- one day, 00 to 24: tracked spans as bars, the gaps between them are untracked time -->
  <div class="relative h-full">
    <!-- 00 is left to the caller's own border -->
    <div
      v-for="hour in AXIS_HOURS.slice(1)"
      :key="hour"
      class="absolute inset-y-0 w-px bg-line/60"
      :style="{ left: dayPercent(hour * 60) }"
    ></div>
    <div
      v-if="now"
      class="absolute -top-px bottom-0 w-[1.5px] bg-accent/50"
      :style="{ left: dayPercent(minutesOfDay(now)) }"
    ></div>
    <div
      v-for="(span, i) in spans"
      :key="i"
      class="absolute top-1/2 flex h-7 -translate-y-1/2 items-center justify-center overflow-hidden
             rounded-[0.375rem] border border-on-accent/25 bg-accent"
      :style="{ left: dayPercent(minutesOfDay(span.from)), width: dayPercent(spanMinutes(span)) }"
      :title="formatFullDuration(span.timeTracked, t)"
    >
      <SpentTime
        v-if="spanMinutes(span) / MINUTES_IN_DAY >= 0.06"
        class="text-label leading-none font-bold text-on-accent"
        :seconds="span.timeTracked"
      />
    </div>
    <slot />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';
import SpentTime from '@/components/elements/SpentTime.vue';
import { formatFullDuration } from '@/utils/formatDuration';
import { AXIS_HOURS, MINUTES_IN_DAY, dayPercent, minutesOfDay } from '@/utils/dayTimeline';

defineProps({
  // [{ from, to, timeTracked }] as the day report returns them
  spans: Array,
  // marks the current time; leave empty for a day other than today
  now: [String, Object],
});

const { t } = useI18n();

const spanMinutes = (span) => dayjs(span.to).diff(dayjs(span.from), 'minutes');
</script>
